import {
    apiRequest,
    daftarpegawai,
    addpegawaitolist,
    daftarpangkat,
    daftarpegawairevisikeuangan,
    PromotionPeriodDetail
} from "../../../../../services/adapters/kepegawaian/revisikeuanganService"

class CreateRepository {

    fetchCreate = async (query) => {
        return await apiRequest("post", addpegawaitolist, {
            body: query
        }, true)
    }
    fetchEmployee = async (query) => {
        return await apiRequest("get", daftarpegawairevisikeuangan, {
            params: query
        }, true)
    }
    fetchRank = async (query) => {
        return await apiRequest("get", daftarpangkat, {
            params: query
        }, true)
    }
    
    fetchDetail = async (query, cancelToken) => {
        return await apiRequest("get", PromotionPeriodDetail, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }

}

export default CreateRepository